import {
  AgentProposalItemReviewStatusFilter,
  BroadcastFeedType,
  CampaignFeedType,
  GroupFeedType,
  HomeFeedType,
  InboxFeedType,
  MyLeadersFeedType,
  NetworkQuestionFeedType,
  NetworkQuestionInboxFeedType,
  TeamsMeetingFeedType,
  TopicUnifiedFeedType,
} from '@ms/yammer-graphql';

import type { FeedType } from '../../state/types';

import type { FeedIdentifier } from './types';

type GetFeedId = (options: FeedIdentifier) => string;

const defaultFeedSubtypeMap: Record<FeedType, FeedIdentifier['subtype']> = {
  AttachableLink: undefined,
  Bookmark: undefined,
  Group: GroupFeedType.ALL,
  Campaign: CampaignFeedType.ALL,
  GroupAgentSuggestions: AgentProposalItemReviewStatusFilter.PENDING,
  GroupTopQuestions: undefined,
  GroupSimilarQuestions: undefined,
  Home: HomeFeedType.DISCOVERY,
  MoreForYou: undefined,
  Inbox: InboxFeedType.ALL,
  InboxDraft: undefined,
  InboxScheduled: undefined,
  LeaderEmployees: undefined,
  LeaderHighlighted: undefined,
  LiveEvent: BroadcastFeedType.ALL,
  MyLeaders: MyLeadersFeedType.ALL,
  DiscoveryNetworkQuestion: undefined,
  NetworkQuestion: NetworkQuestionFeedType.ALL,
  NetworkQuestionInbox: NetworkQuestionInboxFeedType.ALL,
  NetworkTheme: undefined,
  Promoted: undefined,
  Search: undefined,
  SingleNetworkQuestion: undefined,
  StorylineAll: undefined,
  StorylineDiscovery: undefined,
  StorylineFollowed: undefined,
  TeamsMeeting: TeamsMeetingFeedType.ALL,
  Thread: undefined,
  Topic: undefined,
  TopicNetworkQuestion: undefined,
  TopicUnified: TopicUnifiedFeedType.ALL,
  User: undefined,
  UserWall: undefined,
  UserGroups: undefined,
  M365CopilotSuggestion: undefined,
};

type GetDefaultSubtype = (type: FeedType) => FeedIdentifier['subtype'];
export const getDefaultSubtype: GetDefaultSubtype = (type) => defaultFeedSubtypeMap[type];

export const getId: GetFeedId = ({ type, entityId, subtype }) => {
  if (type === 'AttachableLink') {
    return attachableLinkFeedId;
  }

  const defaultedSubtype = subtype || getDefaultSubtype(type);
  // We don't want consumers manually constructing feed IDs, so we base64-encode them.
  const id = [type, entityId, defaultedSubtype].join('/');

  return `${id}-${btoa(id)}`;
};

export const networkQuestionInboxUnreadFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: NetworkQuestionInboxFeedType.UNREAD,
});

export const networkQuestionInboxAllFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: NetworkQuestionInboxFeedType.ALL,
});

export const networkQuestionInboxThreadStarterSenderFeedId: string = getId({
  type: 'NetworkQuestionInbox',
  subtype: NetworkQuestionInboxFeedType.VIEWER_IS_THREAD_STARTER_SENDER,
});

export const inboxUnreadFeedId: string = getId({ type: 'Inbox', subtype: InboxFeedType.UNREAD });

export const inboxDirectFeedId: string = getId({ type: 'Inbox', subtype: InboxFeedType.DIRECT });

export const inboxAllFeedId: string = getId({ type: 'Inbox', subtype: InboxFeedType.ALL });

export const myLeadersUnseenFeedId: string = getId({ type: 'MyLeaders', subtype: MyLeadersFeedType.UNSEEN });

export const attachableLinkFeedId = 'attachableLinkFeedId';
